import { useEffect, useState , Fragment} from 'react';
import { Api } from '../../componentes/Api';
import { Card, Badge,CardBody, Row, Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import * as moment from 'moment';
import Seguros from './Seguros';
import Doctores from './Doctores'
import { CVentasLineas } from './CVentaLineas';
import Clientes from '../Ventas/Clientes';

const TAX_RATE = 0.18;


const modeloDatos = {
    pedidoID: 0,
    cedula: "",
    empresaID: 0,
    numeroUnico: 0,
    clienteID: 1,
    nombreCliente: "",
    doctorID: 0,
    nombreDoctor: "",
    seguroID: 1,
    nombreSeguro: "",
    referidorID: 0,
    tecnicoID: 0,
    rnc: "",
    noPoliza: "",
    cobertura: 0.00,
    reclamacion: "",
    tipoComprobante: "1",
    telefono: "",
    ncf: "",
    facturado: false,
    fecha: new Date,
    comentario: "",
    estatus: 0,
    montoTotalCobertura: 0.00,
    subTotal: 0.00,
    totalDescuento: 0.00,
    totalITBIS: 0.00,
    devolucion: 0.00,
    totalPago: 0.00,
    estatusDiagnostico: 0,
    porcientoAcc: 0.00,
    porcientoRef: 0.00

}
const modeloDatos1 = {
    pedidoLineaID: 0,
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    articuloID: 0,
    descripcionArticulo: "",
    telefono: "",
    almacenID: 0,
    cantidad: 0,
    costo: 0.00,
    precio: 0.00,
    montoCobertura: 0.00,
    cobertura: 0.00,
    precio: 0.00,
    precioSinITBIS: 0.00,
    ItbisIncluido: false,
    itbis: 0.00,
    descuento: 0.00,
    totalLinea: 0.00,
    fecha: new Date,
    editando: false
}


const modeloDatos1F = {

    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    noFactura: "",
    clienteID: 0,
    nombreCliente: "",
    rnc: "",
    tipoComprobante: "",
    ncf: "",
    telefono: "",
    fecha: new Date,
    comentario: "",
    facturado: false,
    estatus: 0,
    credito:0.00,
    efectivo: 0.00,
    tarjeta: 0.00,
    transferencia: 0.00,
    cheque: 0.00,
    totalPago: 0.00,
    devolucion: 0.00,
    montoTotalCobertura: 0.00,
    creadoPor: "",
    fechaCreado: new Date,


}


let options = [];
let optionsDoctor = [];
let optionsReferidor = [];
let optionsSeguro = [];
let options1 = [];
let Lineas = [];
let SubTotal = 0;
let TotalDescuento = 0;
let TotalITBIS = 0;
let TotalCobertura = 0;
let Total = 0;
let Pago = 0;
let migrado;
let salir = 1;
export default function Venta({ data, onData }) {

  
    migrado = data;
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [interativo, Setinterativo] = useState(false);

    const [tabla, setTabla] = useState(modeloDatos);
    const [tabla1, setTabla1] = useState(modeloDatos1);
    const [Listado, SetListado] = useState([]);
    const [ListadoDoctor, SetListadoDoctor] = useState([]);
    const [ListadoNumeroUnico, SetListadoNumeroUnico] = useState([]);
    const [ListadoLineas, SetListadoLineas] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [SN, SetSN] = useState([]);
    const [ListadoArticulos, SetListadoArticulos] = useState([]);
    const [ListadoClientes, SetListadoClientes] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModalPago, setVerModalPago] = useState(false);

    const [verModal, setVerModal] = useState(false);
    const [verModalCliente, setVerModalCliente] = useState(false);
    const [verModalSeguro, setVerModalSeguro] = useState(false);
    const [verModalArticulos, setVerModalArticulos] = useState(false);
    const [verModalEditLinea, setverModalEditLinea] = useState(false);
    const [V_Procesar, setV_Procesar] = useState(false);
    const [EnterProcesar, setEnterProcesar] = useState([], "", "", 1);
    const [EditLinea, setEditLinea] = useState(false);
    const [busqueda, setbusqueda] = useState("");
    const [Empresa, setEmpresa] = useState();
    const itbisIncluidoEmpresa = Boolean(Empresa?.itbisIncluido);
    const tipoComprobanteNum = Number(tabla?.tipoComprobante ?? 0);
    const esCotizacion = tipoComprobanteNum === 3;
    const aplicaImpuestos = tipoComprobanteNum !== 3;
    const aplicaITBISPorEmpresa = aplicaImpuestos && itbisIncluidoEmpresa;

    //const [tabla, setTabla] = useState(modeloDatos);
    const [tabla2, setTabla2] = useState(modeloDatos1F);

    //Otro Lado
    if (migrado != null) {
    tabla.cedula = migrado.cedula
    tabla.nombreCliente = migrado.nombres + ' ' + migrado.apellidos
    tabla.telefono = migrado.telefono
    tabla.seguroID = migrado.seguroID
        tabla.noPoliza = migrado.poliza

 }
    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);

        var searchData = l.filter((item) => {
            if (
                (item.nombreCliente + item.pedidoID)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };
    let use = JSON.parse(user || "{}");

    const toSafeNumber = (value, fallback = 0) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : fallback;
    };

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const calcularTotalesLinea = ({
        precio = 0,
        cantidad = 1,
        descuento = 0,
        cobertura = 0,
        itbisIncluido = false,
        aplicaITBIS = true
    }) => {
        const precioSeguro = Math.max(0, toSafeNumber(precio));
        const cantidadSegura = Math.max(1, toSafeNumber(cantidad, 1));
        const descuentoSeguro = Math.max(0, toSafeNumber(descuento));
        const coberturaSegura = clamp(toSafeNumber(cobertura), 0, 100);

        let precioSinITBIS = precioSeguro;
        let itbisUnitario = 0;

        if (aplicaITBIS) {
            if (itbisIncluido) {
                precioSinITBIS = precioSeguro / (1 + TAX_RATE);
                itbisUnitario = precioSeguro - precioSinITBIS;
            } else {
                precioSinITBIS = precioSeguro;
                itbisUnitario = precioSeguro * TAX_RATE;
            }
        }

        const subtotalBase = precioSeguro * cantidadSegura;
        const totalITBIS = aplicaITBIS ? (itbisUnitario * cantidadSegura) : 0;
        const subtotalConImpuesto = subtotalBase + totalITBIS;
        const descuentoAplicado = Math.min(descuentoSeguro, subtotalConImpuesto);
        const baseNeta = subtotalConImpuesto - descuentoAplicado;
        const montoCobertura = baseNeta * (coberturaSegura / 100);
        const totalLinea = Math.max(0, baseNeta - montoCobertura);

        return {
            precio: precioSeguro,
            cantidad: cantidadSegura,
            descuento: descuentoAplicado,
            cobertura: coberturaSegura,
            precioSinITBIS,
            itbis: itbisUnitario,
            montoCobertura,
            totalLinea
        };
    };


    const handleChange = (e) => {
        if (e.target.name == "cedula" && e.target.value.length > 10) {
            ValidarCedula(e.target.value);
        }


        if (e.target.name == "rnc" && e.target.value.length > 8) {
            ValidarRNC(e.target.value);
        }
        if (e.target.name == "tipoComprobante") {

            var vsn = SN.filter(x => x.secuenciaID == e.target.value).map(x => { return x.maximo - x.siguiente });

            if (vsn[0] < 0) {
                alert("Quedan:" + vsn)
            } else {
                setTabla({
                    ...tabla,
                    [e.target.name]: e.target.value
                })
            }


        } else {
            setTabla({
                ...tabla,
                [e.target.name]: e.target.value
            })
        }
    }

    const handleChangeP = (e) => {

        setTabla2({
            ...tabla2,
            [e.target.name]: e.target.value, ["formaPago"]: e.target.name
        })
    }


    const ValidarRNC = async (x) => {
        let response1 = await fetch(Api + "DGII/ConsultaDGII" + "/" + x);
        if (response1.ok) {
            let data1 = await response1.json()
            if (data1 != false) {
                setTabla({
                    ...tabla, nombreCliente: (data1).descripcion, rnc: x
                })
            } else {
                setTabla({
                    ...tabla, comercio: "", rnc: x
                })
            }
        }
    }
    //Validar Cedula
    const ValidarCedula = async (x) => {

        var nomb = Listado.filter(e => e.cedula == x).map(d => d);

        if (nomb.length != 0) {
            tabla.nombreCliente = (nomb[0]).nombreCliente;
            tabla.cedula = x; tabla.seguroID = (nomb[0]).seguroID; tabla.doctorID = (nomb[0]).doctorID;
            tabla.noPoliza = (nomb[0]).noPoliza;
            tabla.telefono = (nomb[0]).telefono
        }
        else {
            let response1 = await fetch(Api + "administracion/ConsultaCed/" + x);
            if (response1.ok) {
                let data1 = await response1.json()
                if (data1 != false) {
                    setTabla({
                        ...tabla, nombreCliente: (data1[0]).nombres + " " + (data1[0]).apellido1 + " " + (data1[0]).apellido2, cedula: x
                    })
                } else {
                    setTabla({
                        ...tabla, nombreCliente: "", cedula: x
                    })
                }
            }
        }
    }

    const MensajeG = (e) => toast.success(e, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",

    });
    const handleChange2 = (e) => {
        if (e.tab == "Seguro") {
            setTabla({
                ...tabla,
                ["seguroID"]: e.value, ["nombreSeguro"]: e.nombre
            })
        }
        if (e.tab == "Doctor") {
            setTabla({
                ...tabla,
                ["doctorID"]: e.value, ["nombreDoctor"]: e.nombre, ["porcientoAcc"]: e.porcto
            })
        }
        if (e.tab == "Cliente") {
            setTabla({
                ...tabla,
                ["clienteID"]: e.value, ["nombreCliente"]: e.nombre, ["rnc"]: e.rnc, ["telefono"]: e.telefono, ["direccionEnvia"]: e.direccion
            })
        }
        if (e.tab == "Referidor") {
            setTabla({
                ...tabla,
                ["referidorID"]: e.value, ["porcientoRef"]: e.porcto
            })
        }
    }

    const handleChange4 = (e) => {
        if (e.target.name == "precio") {
            const calculo = calcularTotalesLinea({
                precio: e.target.value,
                cantidad: tabla1.cantidad || 1,
                cobertura: tabla.cobertura,
                descuento: tabla1.descuento || 0,
                itbisIncluido: itbisIncluidoEmpresa,
                aplicaITBIS: aplicaITBISPorEmpresa
            });
            setTabla1({
                ...tabla1,
                ["precio"]: calculo.precio, ["itbis"]: calculo.itbis,
                ["precioSinITBIS"]: calculo.precioSinITBIS,
                ["totalLinea"]: calculo.totalLinea,
                ["montoCobertura"]: calculo.montoCobertura

            })

        }
    }
    const handleChange3 = (e) => {
        if (!e) return;
        const calculo = calcularTotalesLinea({
            precio: e.precio,
            cantidad: 1,
            cobertura: tabla.cobertura,
            descuento: 0,
            itbisIncluido: itbisIncluidoEmpresa,
            aplicaITBIS: aplicaITBISPorEmpresa
        });
        setTabla1({
            pedidoLineaID: 0, empresaID: 1, pedidoID: tabla.pedidoID, numeroUnico: tabla.numeroUnico,
            orden: 1, articuloID: e.value, descripcionArticulo: e.nombre, almacenID: e.almacenID,
            cantidad: calculo.cantidad, costo: e.costo, precio: calculo.precio, itbis: calculo.itbis,
            descuento: calculo.descuento, precioSinITBIS: calculo.precioSinITBIS, itbisIncluidoP: e.itbisIncluido,
            totalLinea: calculo.totalLinea, fecha: new Date, cobertura: calculo.cobertura, montoCobertura: calculo.montoCobertura
        })
    }

    // GuardarLinea()  
    const GuardarLinea = async (e) => {
        tabla1.pedidoID = e;
        if (tabla1.pedidoID != 0) {
            let response = await fetch(Api + "Pacientes/GuardarPedidoLineas", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla1)
            })
            if (response.ok) {
                obtenerDatosLineas(e);
                MensajeG("Servicio Agregado")

            }
        }
    }

    const EditarLinea1 = async (x, valor, campo, sl) => {
        setV_Procesar(false)

        if (campo == 'editando') { x.editando = valor; }
        if (campo == 'descripcion') { x.descripcionArticulo = valor; }
        if (campo == 'cantidad') {
            x.cantidad = valor === '' ? 1 : Math.max(1, toSafeNumber(parseInt(valor), 1));
        }
        if (campo == 'cobertura') {
            x.cobertura = valor === '' ? 0 : clamp(toSafeNumber(parseInt(valor)), 0, 100);
        }
        if (campo == 'precio') {
            x.precio = valor === '' ? 0 : Math.max(0, toSafeNumber(valor));
        }
        if (campo == 'descuento') {
            x.descuento = valor === '' ? 0 : Math.max(0, toSafeNumber(valor));
        }
        const calculo = calcularTotalesLinea({
            precio: x.precio,
            cantidad: x.cantidad,
            cobertura: x.cobertura,
            descuento: x.descuento,
            itbisIncluido: itbisIncluidoEmpresa,
            aplicaITBIS: aplicaITBISPorEmpresa
        });
        x.precio = calculo.precio;
        x.cantidad = calculo.cantidad;
        x.cobertura = calculo.cobertura;
        x.descuento = calculo.descuento;
        x.precioSinITBIS = calculo.precioSinITBIS;
        x.itbis = calculo.itbis;
        x.totalLinea = calculo.totalLinea;
        x.montoCobertura = calculo.montoCobertura;


        SetListadoLineas(ListadoLineas.map(p => p.pedidoLineaID === sl ? {
            ...p, ...x
        } : p));


        // setEnterProcesar(x, valor, campo, sl);
        let response = await fetch(Api + "Pacientes/EditarPedidoLineas", {
            method: 'put',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(x)
        })
        if (response.ok) {
            setEditLinea(false)
            obtenerDatosLineas(tabla.pedidoID);

            toast.success("Agregado")
        }
    }

    //Editar lineas
    const EditarLinea = async (x, valor, campo, sl) => {
        setV_Procesar(false)

        if (campo == 'Editar') { x.editando = 0; }
        //if (campo == 'cantidad') {
        //    if (valor == '') { x.cantidad = 1; } else { x.cantidad = valor; } }
        //if (campo == 'precio') {
        //    if (valor == '') { x.precio = 0 }else { x.precio = valor; } }
        //if (campo == 'descuento') {
        //    if (valor == '') { x.descuento = 0 } else { x.descuento = valor; }

        //}
        //if (itbisIncluidoEmpresa) {
        //    var itb = 0.00;
        //    var p = x.precio - x.descuento;
        //    p = p * parseFloat( x.cantidad)
        //    var PrecioSinITBIS = ((p) / 1.18) / parseFloat(x.cantidad);
        //    itb = (p / parseFloat(x.cantidad)) - PrecioSinITBIS;
        //    var total = PrecioSinITBIS + itb;
        //    x.precioSinITBIS = PrecioSinITBIS;
        //} else {
        //    var p = x.precio - x.descuento;
        //    p = p * parseFloat(x.cantidad)
        //    var itb = 0.00;
        //    itb = (parseFloat(p) * 0.18) / parseFloat(x.cantidad);
        //    x.precioSinITBIS = parseFloat(p) / parseFloat(x.cantidad);
        //    var total = parseFloat(p) + (parseFloat(itb) * parseFloat(x.cantidad));
        //}
        //x.itbis = itb;
        //x.totalLinea = total;
        x.editando = valor;
        SetListadoLineas(ListadoLineas.map(p => p.pedidoLineaID === sl ? {
            ...p, x
        } : p));

        let response = await fetch(Api + "Pacientes/EditarPedidoLineas", {
            method: 'put',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(x)
        })
        if (response.ok) {
            setEditLinea(false)
            obtenerDatosLineas(tabla.pedidoID);

            toast.success("Agregado")
        }
    }

    // MAESTRAS
    const obtenerDatos = async (e) => {
        let response = await fetch(Api + "Pacientes/ListaPedido");
        if (response.ok) {
            let data = await response.json();
            //         let data = data1.filter(x => x.estatus < 1).map(x => x);
            SetListado1(data)
            if (e == 1) {
                setPendiente(true)
                SetListado(data)
            }

            if (pendiente) {
                SetListado(data)
                setPendiente(false)
            }
        }
    }
    const obtenerDatosSN = async (e) => {
        try {
            let response = await fetch(Api + "Administracion/SecuenciaNumerica");
            if (response.ok) {
                let data = await response.json();
                SetSN(data)
            }
        } catch (error) {
            console.error("Error al cargar secuencia numérica:", error);
        }
    }
    const obtenerDatosEmpresa = async (e) => {
        try {
            let response = await fetch(Api + "Administracion/ListaEmpresas/" + use.empresaID);
            if (response.ok) {
                let data = await response.json();
                var d = data.filter(x => x.empresaID == use.empresaID).map(e => e)[0]
                setEmpresa(d || { itbisIncluido: false })
            }
        } catch (error) {
            console.error("Error al cargar empresa:", error);
            setEmpresa({ itbisIncluido: false });
        }
    }

    /// mandar venta a caja para pago
    const EnviarCaja = async (p) => {
        Swal.fire({
            title: 'Enviar a Caja',
            text: "Estas seguro de que desea enviar a caja. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {
                let response = fetch(Api + "VentasTrans/EnviarCaja/" + p);
                if (response.ok) {
                    let data = response.json()

                }

                setVerModal(false);
                setPendiente(false);
                obtenerDatos(1);

            }
        })

    }
    const obtenerDatosLineas = async (pl) => {
        let response = await fetch(Api + "Pacientes/ListaPedidoLineas/" + pl);
        if (response.ok) {
            let data = await response.json()
            const lineasCalculadas = data.map((linea) => ({
                ...linea,
                ...calcularTotalesLinea({
                    precio: linea.precio,
                    cantidad: linea.cantidad,
                    descuento: linea.descuento,
                    cobertura: linea.cobertura,
                    itbisIncluido: itbisIncluidoEmpresa,
                    aplicaITBIS: aplicaITBISPorEmpresa
                })
            }));

            SetListadoLineas(lineasCalculadas)
            SubTotal = lineasCalculadas.reduce((x, y) => x + (toSafeNumber(y.precio) * toSafeNumber(y.cantidad, 1)), 0);
            TotalDescuento = lineasCalculadas.reduce((x, y) => x + toSafeNumber(y.descuento), 0);
            TotalITBIS = aplicaITBISPorEmpresa
                ? lineasCalculadas.reduce((x, y) => x + (toSafeNumber(y.itbis) * toSafeNumber(y.cantidad, 1)), 0)
                : 0;
            TotalCobertura = lineasCalculadas.reduce((x, y) => x + toSafeNumber(y.montoCobertura), 0);
            Total = lineasCalculadas.reduce((x, y) => x + toSafeNumber(y.totalLinea), 0);


        }
    }

    const NumeroUnico = async () => {
        let response = await fetch(Api + "VentasMantenimiento/NumeroUnico");
        if (response.ok) {
            let data = await response.json()

            SetListadoNumeroUnico(data.filter(x => x.Pantalla == "Facturacion" && x.ID == 1).map(x => x))
        }
    }


    const obtenerDatosArticulas = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaArticulos/"+ use.correo);

        if (response.ok) {
            let data = await response.json()
            SetListadoArticulos(data)
            options1 = []
            data.filter(x => x.activo == true).map(x => {
                options1.push({
                    value: x.articuloID, label: x.articuloID + "-" + x.descripcion, nombre: x.descripcion,
                    almacenID: x.almacenPorDefecto, costo: x.costoPromedio, precio: x.precioPromedio, Cant_min: x.cantidadMinima, cambiarDescripcion: x.cambiarDescripcion
                    , cambiarPrecio: x.cambiarPrecio, itbisIncluido: x.itbisIncluido
                })
            })
        }
    }

    const obtenerDatosClientes = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaClientes");

        if (response.ok) {
            let data = await response.json()
            SetListadoClientes(data)
            options = []
            data.map(x => {
                options.push({ value: x.clienteID, label: x.rnc + "-" + x.descripcion, nombre: x.descripcion, rnc: x.rnc, telefono: x.telefono, direccion: x.direccion, tab: 'Cliente' })
            })
            tabla.clienteID = 1;
        }
    }
    const obtenerDatosDoctor = async () => {
        let response = await fetch(Api + "CMantenimiento/listaDoctores/" + use.correo);

        if (response.ok) {
            let data = await response.json()
            SetListadoDoctor(data)
            optionsDoctor = [];
            data.map(x => {
                optionsDoctor.push({ value: x.doctorID, label: x.nombreDoctor, nombre: x.nombreDoctor, tab: 'Doctor', porcto: x.porcientoAcionista })
                optionsReferidor.push({ value: x.doctorID, label: x.nombreDoctor, nombre: x.nombreDoctor, tab: 'Referidor', porcto: x.porcientoReferido })
            })
        }
    }
    const obtenerDatosSeguro = async () => {
        let response = await fetch(Api + "CMantenimiento/ListaSeguros/" + JSON.parse(user).correo + "/1");


        if (response.ok) {
            let data = await response.json()
            optionsSeguro = []
            data.map(x => {
                optionsSeguro.push({ value: x.seguroID, label: x.descripcion, nombre: x.descripcion, tab: 'Seguro' })
            })
        }
    }




    useEffect(() => {
        obtenerDatos();
        NumeroUnico();
        obtenerDatosSN();
        obtenerDatosEmpresa()
        obtenerDatosArticulas();
        obtenerDatosClientes()
        obtenerDatosSeguro();
        obtenerDatosDoctor();
    }, [])

    //Guardar factura
    const guardarCambios = async () => {
        if (tabla.pedidoID == 0) {
            let response;
            tabla.empresaID = use.empresaID;
            if (tabla.pedidoID == 0) {

                tabla.pedidoID = 0;

                response = await fetch(Api + "Pacientes/GuardarPedido1", {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(tabla)
                })

            } else {
                response = await fetch(Api + "Pacientes/EditarPedido", {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(tabla)
                })
            }

            if (response.ok) {
                let data = await response.json()
                setTabla(data);
                setPendiente(true)
                obtenerDatos();

                obtenerDatosLineas(data.pedidoID);


                GuardarLinea(data.pedidoID)

            } else {
                alert("error al guardar")
            }
        } else {
            GuardarLinea(tabla.pedidoID)
        }
    }
    //Quitar lienas
    const quitarArticulo = async (id) => {
        let response = await fetch(Api + "Pacientes/QuitarArticulo/" + id, { method: "DELETE" })
        if (response.ok) {
            toast.success("Proceso realizado")
            setPendiente(true)
            obtenerDatosLineas(tabla.pedidoID);
        }
    }


    //sumar secuencia numerica
    const Nuevo = async () => {
        let response = await fetch(Api + "VentasMantenimiento/SumNumeroUnico/1/Facturacion");
        if (response.ok) {
            let data = await response.json()
            tabla.numeroUnico = data;
            setVerModal(!verModal)
            setTabla(modeloDatos);
            setTabla1(modeloDatos1);
        }
        obtenerDatosArticulas();
        obtenerDatosClientes()

    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
        obtenerDatosLineas(data.pedidoID);
    }
    const cerrarModal = () => {
        //if (migrado != null) {
        //    onData(false);
        //}
        obtenerDatos();
        setTabla(modeloDatos);
        SetListadoLineas([]);
        setTabla1(modeloDatos1);
        setVerModal(false)

    }


    //Proceso de pago factura
    const ProcesarPago = async () => {

        var procesar = ((parseFloat(tabla2.efectivo) +
            parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
            + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);
        if (procesar >= -0) {
            tabla2.pedidoID = tabla.pedidoID;
            tabla2.empresaID = tabla.empresaID;
            tabla2.estatus = 1;
            tabla2.clienteID = tabla.clienteID;
            tabla2.nombreCliente = tabla.nombreCliente;
            tabla2.ncf = tabla.ncf;
            tabla2.numeroUnico = tabla.numeroUnico;
            tabla2.rnc = tabla.rnc;
            tabla2.telefono = tabla.telefono;
            tabla2.tipoComprobante = tabla.tipoComprobante
            tabla2.comentario = tabla.comentario;
            tabla2.SubTotal = SubTotal;
            tabla2.TotalDescuento = TotalDescuento;
            tabla2.TotalITBIS = TotalITBIS;
            tabla2.totalPago = Total;
            tabla2.credito = parseFloat(tabla2.credito);
            tabla2.efectivo = parseFloat(tabla2.efectivo);
            tabla2.tarjeta = parseFloat(tabla2.tarjeta);
            tabla2.cheque = parseFloat(tabla2.cheque);
            tabla2.transferencia = parseFloat(tabla2.transferencia);
            tabla2.devolucion = ((parseFloat(tabla2.efectivo) +
                parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
                + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);
            tabla2.creadoPor = use.correo;
            tabla2.montoTotalCobertura = TotalCobertura;


            let response = await fetch(Api + "Pacientes/ProcesarFactura", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla2)
            })
            if (response.ok) {
                var ped = tabla.pedidoID;
              
                setPendiente(false)
                setTabla2(modeloDatos1F)
                setTabla(modeloDatos);
                setVerModalPago(false);
                setVerModal(false);
                  Swal.fire(
                    'Guardado!',
                    '',
                    'success'
                )

                SetListadoLineas([]);
                obtenerDatos(1); 
                
                window.open("/CImpresionFactura/" + ped, '_blank');
                setTabla(modeloDatos);
                //if (migrado != null) {
                //    onData(false);
                //}
               
            }
        } else {
            Swal.fire(
                'No se puede procesar el pago!',
                'Favor revisar la distribución del pago. Restan:' + procesar,
                'warning'
            )
        }
    }
    //Proceso de Cotizacion
    const ProcesarCotizacion = async () => {
        var procesar = ((parseFloat(tabla2.efectivo) +
            parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
            + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);
        if (procesar >= -0) {
            tabla2.pedidoID = tabla.pedidoID;
            tabla2.empresaID = tabla.empresaID;
            tabla2.estatus = 1;
            tabla2.clienteID = tabla.clienteID;
            tabla2.nombreCliente = tabla.nombreCliente;
            tabla2.ncf = tabla.ncf;
            tabla2.numeroUnico = tabla.numeroUnico;
            tabla2.rnc = tabla.rnc;
            tabla2.telefono = tabla.telefono;
            tabla2.tipoComprobante = tabla.tipoComprobante
            tabla2.comentario = tabla.comentario;
            tabla2.SubTotal = SubTotal;
            tabla2.TotalDescuento = TotalDescuento;
            tabla2.TotalITBIS = TotalITBIS;
            tabla2.totalPago = Total;
            tabla2.credito = parseFloat(tabla2.credito);
            tabla2.efectivo = parseFloat(tabla2.efectivo);
            tabla2.tarjeta = parseFloat(tabla2.tarjeta);
            tabla2.cheque = parseFloat(tabla2.cheque);
            tabla2.transferencia = parseFloat(tabla2.transferencia);
            tabla2.devolucion = ((parseFloat(tabla2.efectivo) +
                parseFloat(tabla2.tarjeta) + parseFloat(tabla2.transferencia)
                + parseFloat(tabla2.cheque) + parseFloat(tabla2.credito)) - Total);

            let response = await fetch(Api + "VentasTrans/ProcesarCotizacion", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla2)
            })
            if (response.ok) {

                obtenerDatos(1);
                setPendiente(false)
                setTabla2(modeloDatos1F)
                setVerModalPago(false);
                setVerModal(false);


                Swal.fire(
                    'Guardado!',
                    '',
                    'success'
                )
            }
        } else {
            Swal.fire(
                'No se puede procesar el pago!',
                'Favor revisar la distribución del pago. Restan:' + procesar,
                'warning'
            )
        }
    }

    //Lista de facturas
    const columns = [
        {
            width: '10%',
            name: '',
            cell: row => (
                <>
                    <Button hidden={row.estatus == 1} color="warning" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>{row.estatuss}
                    <Button hidden={row.estatus != 1} color="primary" size="sm" className="mr-2"
                        target="_blank" href={"/CImpresionFactura/" + row.pedidoID}
                    >
                        {/*ImpresionFactura*/}
                        <i className="fas fa-print"></i>
                    </Button>
                </>
            ),
        },
        {
            name: 'ID',
            selector: row => row.pedidoID,
            sortable: true,
            width: '15%',
        },
        {
            name: 'Cliente',
            selector: row => row.nombreCliente,
            sortable: true,
            width: '35%',
        }, {
            name: 'Fecha',
            selector: row => (moment(row.fecha).format("DD/MM/YYYY")),
            sortable: true,
            width: '20%',
        },
        {
            name: 'Total',
            selector: row => (toMoney(row.totalPago)),//.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
            sortable: true,
            width: '20%',

        },


    ];

    //Tabla lineas
    const columns1 = [
        {
            //<Button size="sm" hidden={row.editando } color="warning"
            //    onClick={() => EditarLinea1(row, true, 'editando', row.pedidoLineaID)}
            //> <i className="fas fa-pen-alt"></i></Button>
            name: 'Art.ID',
            selector: row => (<>

                {row.editando ? (
                    <Button
                        size="sm"
                        color="success"
                        onClick={() => EditarLinea(row, false, 'guardar', row.pedidoLineaID)}
                    >
                        <i className="fas fa-save"></i>
                    </Button>
                ) : (
                    <Button
                        size="sm"
                        color="warning"
                        onClick={() => EditarLinea1(row, true, 'editando', row.pedidoLineaID)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                )}
                {" "}{row.articuloID}
            </>),
            sortable: true,
            width: "7%",

        },
        {//disabled={!row.editando}
            name: 'Descripcion',
            selector: row => (
                <> {row.editando ?(
                    < Input value={row.descripcionArticulo} onChange={(e) => EditarLinea1(row, e.target.value, 'descripcion', row.pedidoLineaID)}></Input>
              ):(row.descripcionArticulo) }      </>),
         
  sortable: true,
            width: "22%"
        },  {
            name: 'Cantidad',
            selector: row => (
                row.editando ? (<Input
                    type="number" value={row.cantidad} onChange={(e) => EditarLinea1(row, e.target.value, 'cantidad', row.pedidoLineaID)} ></Input>
                ) : (toMoney(row.cantidad))               ),
            sortable: true,
            width: "10%",
        },{
            name: 'Precio',
            selector: row => (row.editando ? (<Input type="number" onChange={(e) => EditarLinea1(row, e.target.value, 'precio', row.pedidoLineaID)} value={row.precio}></Input>) : (toMoney(row.precio))),
            sortable: true,
            width: "15%",
        },{
            name: '% Cobertura',
            selector: row => (row.editando ? (<Input type="number" onChange={(e) => EditarLinea1(row, e.target.value, 'cobertura', row.pedidoLineaID)} value={row.cobertura}></Input>) : (row.cobertura)),
            sortable: true,
            width: "10%",
    },{
            name: 'Descuento',
            selector: row => (row.editando ? (<Input type="number" onChange={(e) => EditarLinea1(row, e.target.value, 'descuento', row.pedidoLineaID)} value={row.descuento}></Input>) : (toMoney(row.descuento))),
            sortable: true,
            width: "10%",
    },
    //{
    //        name: 'Pr. Sin ITBIS',
    //    selector: row => (toMoney(row.precioSinITBIS)),//.toFixed(2)(row.itbis.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")),
    //        sortable: true,
    //        width: "10%",
    //}, {
    //    name: 'ITBIS',
    //    selector: row => (toMoney(row.itbis)),//(row.itbis.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")),
    //        sortable: true,
            
    //},
    {
            name: 'Total',
        selector: row => ((toMoney(row.totalLinea ) )),
            sortable: true,
            width: "10%",
        },

    
        {
            name: '',
            cell: row => (
                <>
                    <Button hidden={tabla.estatus>=1} size="sm" color="danger"
                        onClick={() => quitarArticulo(row.pedidoLineaID)}
                    >X</Button>
                </>
            ),
            width: "5%",
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
                paddingRight: '1px',
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
                minHeight: '30px',
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };
    
    useEffect(() => {
        if (migrado != null && verModal == false) {
            NumeroUnico();
            obtenerDatosSN();
            obtenerDatosArticulas();
            obtenerDatosEmpresa();
            tabla.clienteID = 1;
        }
    }, [migrado, verModal]);
    const toMoney = (value) => {
        const money = Number(value);

        if (isNaN(money)) {
            return value;
        }

        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(money)
    }
    const [menuPosition, setMenuPosition] = useState(false);

    const handleContextMenu = (event) => {
        event.preventDefault();
        setMenuPosition({
            x: event.pageX,
            y: event.pageY,
        });
    };

    const handleCloseMenu = () => {
        setMenuPosition(false);
    };
    const Asignarvalor = (p) => {

        switch (p) {
            case "CR":
                return setTabla2({ ...tabla2, credito: Total, efectivo: 0, transferencia: 0, cheque: 0, tarjeta: 0 });
            case "TR":
                return setTabla2({ ...tabla2, credito: 0, efectivo: 0, transferencia: Total, cheque: 0, tarjeta: 0 });
            case "CH":
                return setTabla2({ ...tabla2, credito: 0, efectivo: 0, transferencia: 0, cheque: Total, tarjeta: 0 });
            case "TA":
              return  setTabla2({ ...tabla2, credito: 0, efectivo: 0, transferencia: 0, cheque: 0, tarjeta: Total });
            default:
              return   setTabla2({ ...tabla2, credito: 0, efectivo: Total, transferencia: 0, cheque: 0, tarjeta: 0 });
                
        }
        
    }

    const AgregarAutorizacion = () => {
        Swal.fire({
            title: 'Enviar a Caja',
            title: 'Agregar Autorización',
            input: 'text',
            inputLabel: 'Escriba el numero de autorizacion del Seguro :',
            inputPlaceholder: "Numero de Autorización",
        
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Agregar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {
                setTabla({
                    ...tabla, reclamacion: result.value
                })

                tabla.reclamacion = result.value;
             let   response =  fetch(Api + "Pacientes/EditarPedido", {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(tabla)
                })
              
            }
        })

     
    }

    const CerrarMantenimientos = () => {
        obtenerDatosClientes()
        obtenerDatosSeguro()
        obtenerDatosDoctor()
        obtenerDatosClientes()
        obtenerDatosArticulas()
        setVerModalArticulos(false)
        setVerModalCliente(false)
        setVerModalSeguro(false)
    }

    //document.addEventListener('keydown', function (event) {
    //    if (event.key === 'Enter') {
    //      alert(EnterProcesar)
    //    }

    //    if (event.key === 'F2') {
    //        console.log("Presionaste F2");
    //    }

    //    if (event.ctrlKey && event.key === 's') {
    //        event.preventDefault(); // evita que el navegador intente guardar la página
    //        guardarCambios();
    //    }
    //});



    const handleChange12 = (id, campo, valor) => {
    //    setLineas((prev) =>
    //        prev.map((item) =>
    //            item.id === id ? { ...item, [campo]: valor } : item
    //        )
    //    );
    };

    const toggleEditar = (id, cancelar = false) => {
        SetListadoLineas((prev) =>
            prev.map((item) => {
                if (item.pedidoLineaID === id) {
                    if (cancelar) return { ...item, editando: false, ...item.original };
                    return {
                        ...item,
                        editando: !item.editando,
                        original: cancelar ? undefined : { ...item }, // para cancelar
                    };
                }
                return item;
            })
        );
    };

   

    const columns4 = [
        {
            name: "Descripción",
            selector: (row) =>
                !row.editando ? (
                    <Input
                        bsSize="sm"
                        value={row.articuloID + row.editando}
                        onChange={(e) => handleChange12(row.id, "descripcion", e.target.value)}
                    />
                ) : (
                    row.articuloID + row.editando
                ),
        },
        {
            name: "Cantidad",
            selector: (row) =>
                !row.editando ? (
                    <Input
                        bsSize="sm"
                        type="number"
                        value={row.cantidad}
                        onChange={(e) => handleChange12(row.id, "cantidad", e.target.value)}
                    />
                ) : (
                    row.cantidad
                ),
        },
        {
            name: "Precio",
            selector: (row) =>
                !row.editando ? (
                    <Input
                        bsSize="sm"
                        type="number"
                        value={row.precio}
                        onChange={(e) => handleChange12(row.id, "precio", e.target.value)}
                    />
                ) : (
                    `$${row.precio}`
                ),
        },
        {
            name: "Acciones",
            cell: (row) =>
                !row.editando ? (
                    <>
                        <Button color="success" size="sm" onClick={EditarLinea(row, false, 'guardar', row.pedidoLineaID)}>
                            💾
                        </Button>{" "}
                        <Button color="secondary" size="sm" onClick={() => toggleEditar(row.pedidoLineaID, true)}>
                            ❌
                        </Button>
                    </>
                ) : (
                    <Button color="warning" size="sm" onClick={() => toggleEditar(row.pedidoLineaID)}>
                        ✏️
                    </Button>
                ),
        },
    ];

    return (
       
        <>
            <ToastContainer />
      
            <Row hidden>
                <Col md={2}>     <Button color="success" size="sm"
                    onClick={() => setVerModal(true)}
                >Consulta</Button></Col>

                <Col hidden md={2}>     <Button color="secundary" size="sm"
                    onClick={() => setVerModalCliente(true)}
                >Crear Seguros</Button>
                </Col>  <Col hidden md={2}>     <Button color="secundary" size="sm"
                    onClick={() => setVerModalArticulos(true)}
                >Crear Doctores</Button>
                </Col> <Col hidden md={2}>     <Button color="secundary" size="sm"
                    onClick={() => setVerModalCliente(true)}
                >Crear Cliente</Button>
                </Col>
            </Row>

            <Card className="cventa-card">
                <CardHeader className="cventa-header">
                                   Informacion del paciente        <Row hidden className="align-items-center text-sm" style={{ fontSize: "14px" }}>
                            <Col md="4">
                                <span className="text-muted">🗓️ Fecha de Proceso:</span>{" "}
                                <Badge color="secondary">{moment(Date.now()).format("DD/MM/YYYY")}</Badge>
                            </Col>
                           
                            <Col md="4">
                                <span className="text-muted">📄 N° Recibo:</span>{" "}
                                <Badge color="success">{tabla.numeroUnico || "N/A"}</Badge>
                            </Col>
                    </Row>
                    <a className="btn" color="primary"
                        onClick={() => Setinterativo(true)} >
                        <i >Guia</i>
                    </a>
                    <Col md={2}>     <Button color="success" size="sm"
                        onClick={() => setVerModal(true)}
                    >Consulta</Button></Col>
                </CardHeader>
                <CardBody>
                   
                    {/*Facturacion*/ }
                    <Row>
                        <Col md="12" className="cventa-body">
                           
                            <Row>
                                <Col md={3} >
                                    <FormGroup>

                                        <Label style={{ color: "red" }}>Tipo Factura NCF</Label>
                                        <Input className="form-control" bsSize="sm" type={"select"} name="tipoComprobante" onChange={handleChange} value={tabla.tipoComprobante} >
                                            {
                                                SN.map((item) => (<option key={item.secuenciaID} value={item.secuenciaID}>{item.descripcion}</option>))
                                            }

                                        </Input>
                                    </FormGroup></Col>
                                <Col md={3} hidden={tipoComprobanteNum === 1} >
                                    <FormGroup>

                                        <Label>* Cliente</Label>
                                        {/*<Input bsSize="sm" name="clienteID" onChange={handleChange} value={tabla.clienteID} />*/}

                                        <Select
                                            name={"clienteID"}
                                            onChange={handleChange2}
                                            defaultValue={options.filter(x => x.value == tabla.clienteID)[0]}
                                            options={options}
                                        />
                                    </FormGroup></Col>

                                <Col md={3} hidden={tipoComprobanteNum === 1} >
                                    <FormGroup>

                                        <Label>RNC</Label>
                                        <Input bsSize="sm" name="rnc" onChange={handleChange} value={tabla.rnc} />
                                    </FormGroup></Col>

                                <Col md={3} >
                                <FormGroup>

                                        <Label>Cedula
                                        <i hidden={tabla.cedula.length == 11} style={{ color: "red" }} className="fas fa-exclamation-circle"></i>
                                        <i hidden={tabla.cedula.length != 11} style={{ color: "green" }} className="fas fa-check"></i>
</Label>
                                        <Input bsSize="sm" name="cedula" onChange={handleChange} value={tabla.cedula} maxlength="11" />
                                    </FormGroup></Col>
                                <Col md={3} >
                                <FormGroup>

                                    <Label>Paciente</Label>
                                    <Input bsSize="sm" name="nombreCliente" onChange={handleChange} value={tabla.nombreCliente} />
                                    </FormGroup></Col>
                                <Col md={2}>
                                    <FormGroup>

                                        <Label>* Doctor</Label>
                                        <Select
                                            name={"doctorID"}
                                            onChange={handleChange2}
                                            value={optionsDoctor.filter(x => x.value == tabla.doctorID).map(x => x)}
                                            options={optionsDoctor}
                                        />
                                    </FormGroup></Col>
                                {/*<Col md={1} >*/}
                                {/*    <FormGroup>*/}

                                {/*        <Label>% Acc</Label>*/}
                                {/*        <Input bsSize="sm" name="porcientoAcc" onChange={handleChange} value={tabla.porcientoAcc} />*/}
                                {/*    </FormGroup></Col>*/}
                                {/* <Col md={2}>*/}
                                {/*    <FormGroup>*/}

                                {/*        <Label>* Referidor</Label>*/}
                                {/*        <Select*/}
                                {/*            name={"referidorID"}*/}
                                {/*            onChange={handleChange2}*/}
                                {/*            value={optionsReferidor.filter(x => x.value == tabla.referidorID).map(x => x)}*/}
                                {/*            options={optionsReferidor}*/}
                                {/*        />*/}
                                {/*    </FormGroup></Col>*/}
                                <Col md={1} >
                                    <FormGroup>

                                        <Label>% Ref</Label>
                                        <Input bsSize="sm" name="porcientoRef" onChange={handleChange} value={tabla.porcientoRef} />
                                    </FormGroup></Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label>* Codigo Seguro</Label>

                                        <Select
                                            name={"seguroID"}
                                            onChange={handleChange2}
                                           
                                            value={optionsSeguro.filter(x => x.value == tabla.seguroID).map(x=>x)}
                                            options={optionsSeguro}
                                        />
                                    </FormGroup></Col>
                             
                                <Col md={3} >
                                    <FormGroup>

                                        <Label>Poliza de seguro</Label>
                                        <Input bsSize="sm" name="noPoliza" onChange={handleChange} value={tabla.noPoliza} />
                                    </FormGroup></Col>
                                <Col md={3} >
                                    <FormGroup>

                                        <Label>No. Autorizacion</Label>
                                        <Input bsSize="sm" name="reclamacion" onChange={handleChange} value={tabla.reclamacion} />
                                    </FormGroup></Col>
                                
                                <Col md={3} >
                                    <FormGroup>

                                        <Label>Telefono</Label>
                                        <Input bsSize="sm" name="telefono" onChange={handleChange} value={tabla.telefono} maxlength="10" />
                                    </FormGroup></Col>
                                {/*<Col md={3} >*/}
                                {/*    <FormGroup>*/}

                                {/*        <Label>Diagnostico</Label>*/}
                                {/*        <Input className="form-control" bsSize="sm" type={"select"} name="estatusDiagnostico" onChange={handleChange} value={tabla.estatusDiagnostico} >*/}
                                {/*           <option  value={0}>Pendiente</option>*/}
                                {/*           <option  value={1}>Entregado</option>*/}
                                {/*        </Input>*/}
                                {/*    </FormGroup></Col>*/}
                              
                               
                           
                            {/*<Col md={6}>*/}
                            {/*    <FormGroup>*/}

                            {/*        <Label>Direccion</Label>*/}
                            {/*        <Input bsSize="sm" name="direccionEnvia" onChange={handleChange} value={tabla.direccionEnvia} />*/}
                            {/*    </FormGroup></Col>*/}
                        
                            <Col hidden md={3} >
                                <FormGroup>

                                    <Label>NCF</Label>
                                    <Input bsSize="sm" name="ncf" onChange={handleChange} value={tabla.ncf} />
                                </FormGroup></Col>

                            

                            {/*<Col md={3} >*/}
                            {/*    <FormGroup>*/}

                            {/*        <Label>Fecha</Label>*/}
                            {/*        <Input bsSize="sm" type="date" name="fecha" onChange={handleChange} value={Moment(tabla.fecha).format('YYYY-MM-DD')} />*/}
                            {/*    </FormGroup></Col>*/}

                            <Col md={9} >
                                <FormGroup>

                                    <Label>Observaciones</Label>
                                        <Input bsSize="sm" rows="1" type="textarea"  name="comentario" onChange={handleChange} value={tabla.comentario} />
                                </FormGroup></Col>

                        </Row>
                            
                            
                            <div hidden={!tabla.nombreCliente} className="cventa-lines-wrap" >
                            <div style={{ border: "1px solid #191aa652" }}></div>
                                {/*<Row style={{ justifyContent: "space-around", alignItems: "center" }}>*/}

                                {/*<Col md={1.5} >*/}
                                {/*    <h5><b>Servicio</b></h5>*/}
                                {/*</Col>*/}
                                {/*<Col md={5} >*/}
                                {/*    <Select*/}
                                {/*        name={"articuloID"}*/}
                                {/*        onChange={handleChange3}*/}
                                {/*        options={options1}*/}
                                {/*    /></Col>*/}
                                {/*    <Col md={1} hidden={!tabla1.articuloID}>*/}
                                {/*        RD$:</Col>*/}
                                {/*    <Col md={2} hidden={!tabla1.articuloID}>*/}
                                        
                                {/*            <Input bsSize="sm" type="number" name="precio" onChange={handleChange4} value={tabla1.precio} />*/}
                                     
                                {/*    </Col>*/}
                                {/*    <Col md={2} >*/}
                                {/*        <Button hidden={!tabla1.articuloID } size="sm" color="primary"*/}
                                {/*            onClick={guardarCambios} */}
                                {/*    >Agregar</Button>*/}
                                {/*</Col>*/}
                                {/*</Row>*/}
                                <Row className="align-items-center cventa-tax-banner">
                                    <Col md={12}>
                                        <small>
                                            {aplicaImpuestos
                                                ? (itbisIncluidoEmpresa
                                                    ? "ITBIS habilitado en empresa (18%)."
                                                    : "ITBIS no habilitado en empresa: no se aplica en el monto.")
                                                : "Cotizacion: ITBIS no aplica."}{" "}
                                            Cobertura permitida: 0% a 100%.
                                        </small>
                                    </Col>
                                </Row>
                                <Row className="align-items-center">
                                    <Col md={2}><b>Servicio</b></Col>
                                    <Col md={5}>
                                        <Select name="articuloID" onChange={handleChange3} options={options1} />
                                    </Col>
                                    {tabla1.articuloID && (
                                        <>
                                            <Col md={1}><span>RD$:</span></Col>
                                            <Col md={2}>
                                                <Input bsSize="sm" type="number" name="precio" onChange={handleChange4} value={tabla1.precio} />
                                            </Col>
                                        </>
                                    )}
                                    <Col md={2}>
                                        <Button hidden={!tabla1.articuloID} size="sm" color="primary" onClick={guardarCambios}>Agregar</Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <div className="cventa-table-wrap" onContextMenu={handleContextMenu}   >
                                        {/*Haz clic derecho en cualquier lugar.*/}

                                <DataTable
                                    columns={columns1}
                                    data={ListadoLineas}
                                    //progressPending={pendiente1}
                                    //  pagination
                                    //    paginationComponentOptions={paginationComponentOptions}
                                    customStyles={customStyles}
                                        />
                                    </div>

                                </Row>

                                {/* Totales y acciones */}
                                <Row className="mt-3 justify-content-between cventa-totals-row">
                                    {tabla.pedidoID !== 0 && (
                                        <Col md="auto">
                                            <h6>
                                                Subtotal: <b>${SubTotal.toFixed(2)}</b> —
                                                Descuento: <b>${TotalDescuento.toFixed(2)}</b> —
                                                Cobertura: <b>${TotalCobertura.toFixed(2)}</b> —
                                                Total: <b>${Total.toFixed(2)}</b>
                                            </h6>
                                        </Col>
                                    )}

                                    <Col md="auto" className="d-flex gap-2">
                                        <Button size="sm" color="danger" onClick={cerrarModal}>Limpiar</Button>

                                        {!esCotizacion && ListadoLineas.length > 0 && !V_Procesar && tabla.pedidoID !== 0 && (
                                            <Button size="sm" color="success" onClick={() => setVerModalPago(true)}>Procesar pago</Button>
                                        )}

                                        {esCotizacion && !tabla.facturado && (
                                            <Button size="sm" color="secondary" onClick={ProcesarCotizacion}>Cotizar</Button>
                                        )}
                                    </Col>
                                </Row>

                             {/*   <Row style={{ justifyContent: "space-around",   alignItems: "center"} }>*/}
                             {/*   <div hidden={tabla.pedidoID == 0}>*/}
                             {/*       Sub Total: <b>${SubTotal.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b>     Total Descuento: <b>${TotalDescuento.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b> Total Cobertura:  <b >${TotalCobertura.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b>  Total A Pagar: <b>${Total.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b>*/}
                             {/*   </div>*/}
                             {/*   */}{/*<Button hidden={tabla.pedidoID != 0 && tabla.estatus == 1} size="sm" color="primary"*/}
                             {/*   */}{/*    onClick={()=>EnviarCaja(tabla.pedidoID)}*/}
                             {/*       */}{/*>Enviar a Caja</Button>   */}
                             {/*       <div className="box">*/}
                              
                             {/*<div>*/}
                             {/*   <Button size="sm" color="danger"*/}
                             {/*       onClick={cerrarModal}*/}
                             {/*               >Limpiar</Button></div>*/}
                             {/*           <div hidden={tabla.tipoComprobante == 3}>    <div hidden={ListadoLineas.length == 0}>*/}
                             {/*               <div hidden={V_Procesar} >                       <Button hidden={tabla.pedidoID == 0} size="sm" color="success"*/}
                             {/*                   onClick={() => setVerModalPago(true)}*/}
                             {/*               >Procesar pago</Button></div></div></div>*/}
                             {/*           <div hidden={tabla.tipoComprobante != 3} >*/}
                             {/*               <Button hidden={tabla.facturado} size="sm" color="secundary"*/}
                             {/*                   onClick={() => ProcesarCotizacion()}*/}
                             {/*               >Cotizar {tabla.facturado}</Button></div>*/}

                             {/*       </div   >*/}

                             {/*   </Row>*/}
                        </div>

                    </Col>
                    {/*Listado*/ }
                    </Row>
                </CardBody>

             

            </Card>
            
            {menuPosition && (
                <ul
                    style={{
                        position: 'absolute',
                        top: menuPosition.y,
                        left: menuPosition.x,
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        listStyle: 'none',
                        padding: '10px',
                        margin: 0,
                    }}
                    onClick={handleCloseMenu} // Cierra el menú al hacer clic.
                >
                    <li>X</li>
                    <li>Opción Segundarias</li>
                    <li><a className="btn" onClick={() => AgregarAutorizacion() }>Agregar Autorizacion</a></li>

                    
                </ul>
            )}
     
            {/*//nuevo modal para pago*/}

            <Modal isOpen={verModalPago}>
                <ModalHeader className="modal-header1">
                    <i className="fas fa-cash-register mr-2"></i> Cobrando a: <strong className="ml-2">{tabla.nombreCliente}</strong>
                </ModalHeader>

                <ModalBody>
                    {/* Totales */}
                    <div className="mb-3">
                        <h6>Sub Total: <b>${SubTotal.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</b></h6>
                        <h6>Total Descuento: <b>${TotalDescuento.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</b></h6>
                        <h6>Total Cobertura: <b>${TotalCobertura.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</b></h6>
                        <h4 className="mt-3">Total A Pagar: <b>${Total.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</b></h4>
                    </div>

                    {/* Formas de pago */}
                    <Row>
                        {[
                            { label: "Efectivo", name: "efectivo", icon: "fas fa-money-bill", tipo: "EF" },
                            { label: "Crédito", name: "credito", icon: "fas fa-comment-dollar", tipo: "CR" },
                            { label: "Tarjeta", name: "tarjeta", icon: "fa fa-credit-card", tipo: "TA" },
                            { label: "Transferencia", name: "transferencia", icon: "fas fa-exchange-alt", tipo: "TR" },
                            { label: "Cheque", name: "cheque", icon: "fa fa-money-check", tipo: "CH" }
                        ].map(({ label, name, icon, tipo }) => (
                            <Col md={6} key={name}>
                                <FormGroup className="d-flex align-items-end">
                                    <div className="w-100">
                                        <Label>{label}</Label>
                                        <div className="d-flex">
                                            <Input
                                                bsSize="sm"
                                                type="number"
                                                name={name}
                                                value={tabla2[name]}
                                                onChange={handleChangeP}
                                                className="mr-2"
                                            />
                                            <Button size="sm" color="success" onClick={() => Asignarvalor(tipo)}>
                                                <i className={icon}></i>
                                            </Button>
                                        </div>
                                    </div>
                                </FormGroup>
                            </Col>
                        ))}
                    </Row>

                    {/* Devuelta */}
                    <div className="mt-4 text-right">
                        <h4 className="text-primary">
                            <strong>
                                Devuelta: ${(
                                    (parseFloat(tabla2.efectivo) +
                                        parseFloat(tabla2.credito) +
                                        parseFloat(tabla2.tarjeta) +
                                        parseFloat(tabla2.transferencia) +
                                        parseFloat(tabla2.cheque)) -
                                    Total
                                ).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                            </strong>
                        </h4>
                    </div>
                </ModalBody>

                <ModalFooter>
                    <Button
                        hidden={tabla.facturado}
                        size="sm"
                        color="success"
                        onClick={ProcesarPago}
                    >
                        <i className="fas fa-check-circle mr-1"></i> Pagar
                    </Button>
                    <Button
                        size="sm"
                        color="danger"
                        onClick={() => setVerModalPago(false)}
                    >
                        <i className="fas fa-times-circle mr-1"></i> Cerrar
                    </Button>
                </ModalFooter>
            </Modal>

            {/*Mantenimiento Seguro*/}

            <Modal isOpen={verModalSeguro} className="modal-preguntas" >
            
                <ModalBody>
       <Seguros></Seguros>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="danger"
                        onClick={() => CerrarMantenimientos()}

                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
            {/*Mantenimiento Cliente*/}

            <Modal isOpen={verModalCliente} className="modal-preguntas" >
            
                <ModalBody>
       <Clientes></Clientes>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="danger"
                        onClick={() => CerrarMantenimientos()}

                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

                {/*Mantenimiento Articulo*/}

            <Modal isOpen={verModalArticulos} >
                <ModalHeader className="modal-header1">
             
                </ModalHeader>
                <ModalBody>
       <Doctores></Doctores>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="danger"
                        onClick={() => CerrarMantenimientos()}

                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

               {/*Mantenimiento Linea en vivo*/}

            <Modal isOpen={verModal} className="modal-preguntas" >
                <ModalHeader className="modal-header1">
             
                </ModalHeader>
                <ModalBody>
                    <Col md={8}>    <Input type="search" name="busqueda" onChange={(e) => onChange(e)} placeholder="Buscar  de factura" ></Input> </Col>

                    <Col md="12" >
                        <DataTable
                            columns={columns}
                            data={Listado}

                            pagination
                            paginationComponentOptions={paginationComponentOptions}
                            customStyles={customStyles}
                            expandableRows
                            expandableRowsComponent={CVentasLineas}
                        />
                    </Col>

    
                 
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="danger"
                        onClick={() => setVerModal(false)}

                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
            {/*AYUDA TUTORIAL*/}
            <Modal className="modal-preguntas" isOpen={interativo}>
                <ModalHeader className="modal-header1">
                    Manuales interativo.
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            {/*<a href="\imagen\Manual de usuario Sistema Evaluación de Desempeño ETED.pdf" target="_blank" >Descargar Manual PDF</a>*/}
                            <video width="100%" height="70%" controls>
                                <source src="\imagen\Ventas.mp4" type="video/mp4" />
                            </video>

                            <Button size="sm" color="danger"
                                onClick={() => Setinterativo(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>

        </>
    )

}
